export const getStaticFile = (path: string) =>
  `${process.env.PUBLIC_URL}/${path}`
